import style from './Card.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import ImgGoogle from '../../assets/LogoCard.png';
import { useState } from 'react';

function Card({ titulo, url, onClick, abrirModalExcluir, abrirModalEdiatr, id }) {
    const [abrirMenu, setAbrirMenu] = useState(false);

    const handleMenu = (e) => {
        e.stopPropagation();
        setAbrirMenu(!abrirMenu);
    }

    const fecharMenu = () => {
        setAbrirMenu(false);
    }

    return (
        <>
            <div className={style.content} onClick={fecharMenu}>
                <div className={style.card_img}>
                    <a href={url} target='_blank'>
                        <img src={ImgGoogle} alt={titulo} />
                    </a>
                </div>

                <div className={style.card_body}>
                    <a href={url} target='_blank'>
                        <h3>{titulo}</h3>
                    </a>
                    <div className={style.div_icon} onClick={handleMenu}>
                        <FontAwesomeIcon icon={faEllipsisV} className={style.menu_icon} />
                    </div>

                </div>

                {abrirMenu && (
                    <div className={style.menu}>
                        <span className={style.menu_item} onClick={() => abrirModalEdiatr(id)}>Editar</span>
                        <span className={style.menu_item} onClick={() => abrirModalExcluir(id)}>Excluir</span>
                    </div>
                )}
            </div>
        </>
    );
}

export default Card;